// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_3xr","productName":"Table_productName__2xVCM"};